import React from 'react';
import { FadeIn } from './FadeIn';
export function CostComparison() {
  const comparisons = [{
    without: 'Descuentos calculados de cabeza',
    cost: 'Cristales mal pedidos y plata perdida'
  }, {
    without: 'Instalación sin protocolo',
    cost: 'Filtraciones y reclamos del cliente'
  }, {
    without: 'Presupuestos a ojo',
    cost: 'Trabajos sin ganancia real'
  }, {
    without: 'Sin planillas para el ayudante',
    cost: 'Taller dependiente del maestro'
  }, {
    without: 'Sin entrega documentada',
    cost: 'Reclamos sin respaldo'
  }, {
    without: 'Sin contrato de señado',
    cost: 'Cristales encargados sin garantía de cobro'
  }];
  return <section className="py-12 relative" data-id="element-73">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-74">
        <FadeIn data-id="element-75">
          <div className="text-center mb-10" data-id="element-76">
            <div className="text-5xl mb-4" aria-hidden="true" data-id="element-77">
              ⚖️
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-78">
              ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-79">
          <div className="bg-surface rounded-2xl border border-white/5 overflow-hidden mb-6" data-id="element-80">
            <div className="grid grid-cols-2 bg-surfaceLight p-4 md:p-6 border-b border-white/5" data-id="element-81">
              <div className="font-bold text-gray-400 uppercase tracking-wider text-sm md:text-base" data-id="element-82">
                Sin El Maestro de las Mamparas
              </div>
              <div className="font-bold text-red-400 uppercase tracking-wider text-sm md:text-base pl-4 md:pl-6 border-l border-white/5" data-id="element-83">
                Costo real
              </div>
            </div>
            <div className="divide-y divide-white/5" data-id="element-84">
              {comparisons.map((item, i) => <div key={i} className="grid grid-cols-2 p-4 md:p-6 hover:bg-white/[0.02] transition-colors" data-id="element-85">
                  <div className="text-gray-300 pr-4" data-id="element-86">{item.without}</div>
                  <div className="text-red-300/80 pl-4 md:pl-6 border-l border-white/5 font-medium" data-id="element-87">
                    {item.cost}
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-88">
          <div className="mt-8 text-center max-w-3xl mx-auto" data-id="element-89">
            <p className="text-xl md:text-2xl text-gold font-bold mb-6" data-id="element-90">
              El próximo trabajo puede ser diferente.
            </p>
            <p className="text-lg text-gray-300 italic" data-id="element-91">
              🚿 "Desde hoy, tu taller de mamparas tiene sistema."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}